

















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page5Chart1 from '../_components/charts/Page5Chart1.vue'
import Page3Chart2 from '../_components/charts/Page3Chart2.vue'
@Component({
  components: {
    MainTitle,
    SubTitle,
    Page5Chart1,
    Page3Chart2
  }
})
export default class extends Vue {
  @Prop({}) private data!: any

  private list: Array < object > = [];
  private itemList: any = [{
    name: '较瘦 得分＜5',
    color: '#3A91FF'
  }, {
    name: '正常 5≤得分≤85',
    color: '#6DD400'
  }, {
    name: '超重 85＜得分≤95',
    color: '#FFA100'
  },
  {
    name: '肥胖 得分＞95',
    color: '#F87A52'
  }
  ]
  private colorList: any = []
  created() {
    this.itemList.map(v => {
      this.colorList.push(v.color)
    })

    let obj: any = this.data.pie
    obj.WeightLastTypeIntro = obj.title
    obj.data = []
    this.data.pie.dataList.map(v => {
      obj.data.push({ name: v.name, value: v.value * 100 })
    })
    this.list.push(obj)
    this.data.staminaWeightPercentVoLine.map(v => {
      this.list.push(v)
    })
  }
}
